// Constants
import Constants from '../constants/constants';

export default {
  getFilterSearchParams(filters) {
    const searchParams = {};

    filters.forEach(nestedFilter => {
      nestedFilter.filters.forEach(({ field, operator, value }) => {
        const operatorTitle = field + Constants.Kendo.filter.operator;
        const valueTitle = field + Constants.Kendo.filter.value;

        searchParams[operatorTitle] = operator;
        searchParams[valueTitle] = value;
      });
    });

    return searchParams;
  },

  getSortSearchParams(sort) {
    const searchParams = {};

    sort.forEach(({ field, dir }) => {
      searchParams[Constants.Kendo.sort.orderBy] = `${field} ${dir}`;
    });

    return searchParams;
  },

  getPaginationSearchParams(take, skip) {
    return {
      pageSize: take,
      pageNumber: skip / take + 1
    };
  },

  getGlobalSearchSearchParams(query, isActive) {
    return {
      query,
      isActive
    };
  }
};
